import { ColorPalette } from './structure';

export const legacyColors: ColorPalette = {
  primary: {
    100: '#10253E',
    95: '#000000DE', // mui text.primary
    90: '#0C0E3E',
    80: '#161957',
    70: '#252977',
    60: '#282E9A',
    50: '#2D34C0',
    45: '#777CE5',
    40: '#565CDE',
    30: '#9397EB',
    20: '#C7C9FB',
    10: '#E7E8FF',
    5: '#F8F8FF',
    0: '#FFFFFF',
  },
  secondary: {
    90: '#140934',
    80: '#231156',
    70: '#31177A',
    60: '#42229C',
    50: '#6A45D3',
    40: '#896ADE',
    30: '#A992EB',
    20: '#CCBFF3',
    10: '#ECE5FF',
    5: '#F8F8FF',
  },
  tertiary: {
    90: '#0C2D38',
    80: '#144D60',
    70: '#1E6A83',
    60: '#2995B8',
    50: '#45B8DD',
    40: '#6EC4DF',
    30: '#9BDBEF',
    20: '#C3ECF9',
    10: '#E0F7FE',
  },
  neutral: {
    80: 'rgba(0, 0, 0, 0.12)',
    70: '#4B525D',
    60: '#636C7B',
    50: '#808999',
    40: '#99A1AD',
    30: '#B6BBC4',
    20: '#D2D5DB',
    10: '#EEEFF1',
    5: '#F9FAFA',
    2: '#FAFAFA',
  },
  critical: {
    60: '#A4282C',
    50: '#D04246',
    40: '#DC7073',
    30: '#E59597',
    20: '#EFBEBF',
    10: '#F9E6E7',
    5: '#FBEFEF',
  },
  warning: {
    70: '#A35F00',
    60: '#CC7700',
    50: '#FF9500',
    40: '#FFB650',
    30: '#FFCC85',
    20: '#FFE1B8',
    10: '#FFF2E0',
  },
  success: {
    70: '#336661',
    60: '#4E9B93',
    50: '#6AB4AC',
    40: '#8CC5BF',
    30: '#AED6D2',
    20: '#D2EEEB',
    10: '#F1F8F7',
  },
  gray: {
    700: '#2D3748',
  },
  // The semantic tokens the New UI introduced, at the values the current UI renders today, so a
  // component can read the role under both UIs.
  text: {
    main: 'rgba(16, 37, 62, 0.87)',
    secondary: 'rgba(63, 73, 89, 0.64)',
    onNavigation: '#FFFFFF',
    secondaryOnNavigation: '#ECE5FF', // secondary[10]
    link: '#282E9A', // primary[60], the accent
    tabSelected: '#282E9A',
    tab: '#808999',
    disabled: 'rgba(0, 0, 0, 0.38)', // MUI's default
  },
  border: {
    default: 'rgba(0, 0, 0, 0.12)', // neutral[80]
    input: 'rgba(0, 0, 0, 0.23)', // MUI's default
    tabIndicator: '#282E9A',
    disabled: 'rgba(0, 0, 0, 0.12)',
    navigation: 'transparent', // no line between the side navigation and its panel
    card: 'rgba(40, 46, 154, 0.12)',
    cardHover: 'rgba(40, 46, 154, 0.17)',
    cardSelected: 'rgba(40, 46, 154, 0.2)',
  },
  surface: {
    app: '#FFFFFF',
    card: 'radial-gradient(100% 204.54% at 0% 0%, rgba(249, 250, 250, 0.8) 0%, rgba(255, 255, 255, 0.32) 100%)',
    cardNested:
      'radial-gradient(100% 204.54% at 0% 0%, rgba(249, 250, 250, 0.8) 0%, rgba(255, 255, 255, 0.32) 100%)',
    navigation: '#232465',
    navigationPanel: 'linear-gradient(182.23deg, #7383cf 0%, #333389 50.61%)',
    navigationSelected: '#2D3277',
    navigationHover: 'rgba(37, 41, 119, 0.2)',
    navigationField: 'rgb(88, 103, 192)',
    badge: '#45B8DD', // tertiary[50]
    selectedSubtle: 'rgba(40, 46, 154, 0.08)',
    hover: '#F8F8FF', // primary[5]
    disabled: 'rgba(0, 0, 0, 0.12)',
    tableStripe: '#FBFCFD',
    tableTotal: '#FBFCFD',
    cardHover: 'rgba(40, 46, 154, 0.12)',
    cardSelected: 'rgba(40, 46, 154, 0.14)',
  },
  icon: {
    main: '#282E9A',
    secondary: 'rgba(0, 0, 0, 0.54)', // MUI's action.active
    link: '#565CDE', // primary[40]
  },
  // The design system's Chip_stage tints
  tint: {
    blue: '#E7E8FF',
    blueForeground: '#282E9A',
    purple: '#ECE5FF',
    purpleForeground: '#31177A',
    yellow: '#FFF2E0',
    yellowForeground: '#CC7700',
    red: '#F9E6E7',
    redForeground: '#D04246',
    green: '#D2EEEB',
    greenForeground: '#336661',
    grey: '#EEEFF1',
    greyForeground: 'rgba(63, 73, 89, 0.64)',
  },
  // Each format family's own branding, so a document type is recognised at a glance.
  fileType: {
    pdf: '#BD0100',
    presentation: '#D44519',
    sheet: '#1B7343',
    word: '#27549B',
    other: '#6A45D3', // secondary[50]
  },
};
